import { useEffect, useState } from 'react';

/**
 * Returns `false` on first paint then `true` after `delay` ms, so width/height
 * transitions animate from their base to their target on mount (the prototype's
 * progress-bar / XP-bar reveal). Honors prefers-reduced-motion via CSS.
 */
export function useMountAnimation(delay = 120): boolean {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    const timer = window.setTimeout(() => setMounted(true), delay);
    return () => window.clearTimeout(timer);
  }, [delay]);
  return mounted;
}
